import { z } from 'zod';
import { ActorSchema } from '../common/actor.schema';

/**
 * Emitted when a workspace's company record is saved (Owner/Admin maintenance
 * in IMM-283). Ids only on the payload per ADR 0015 §PII — the changed field
 * values are not carried.
 */
export const CompanyUpdatedPayloadSchema = z.object({
  companyId: z.uuid(),
  workspaceId: z.uuid(),
  actor: ActorSchema,
  occurredAt: z.iso.datetime(),
});

export type CompanyUpdatedPayload = z.infer<typeof CompanyUpdatedPayloadSchema>;
